import { useState, useCallback, useRef, useEffect } from "react"
import { userInitialState } from "../../initialStates"
import UserService from "~services/UserService"

export const useUser = (callback: (user: any) => void) => {
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(null)
  const isMountedRef = useRef(true)

  useEffect(() => {
    isMountedRef.current = true
    return () => {
      isMountedRef.current = false
    }
  }, [])

  const fetchUser = useCallback(
    async (searchParams: Record<string, any>) => {
      try {
        if (isMountedRef.current) setLoading(true)

        if (searchParams.id) {
          const user = await UserService.getUserById(searchParams.id, false)
          if (isMountedRef.current && user) {
            callback(user)
          } else if (isMountedRef.current) {
            callback(userInitialState)
          }
        } else if (searchParams.email) {
          const result = await UserService.getUsers({
            email: searchParams.email,
          })
          const users = result._embedded?.users || []
          const foundUser = users.find(
            u => u.email === decodeURIComponent(searchParams.email),
          )
          if (isMountedRef.current) {
            callback(foundUser || userInitialState)
          }
        } else if (isMountedRef.current) {
          callback(userInitialState)
        }
      } catch (err) {
        console.error("Failed to fetch user", err)
        if (isMountedRef.current) {
          callback(userInitialState)
          setError(err)
        }
      } finally {
        if (isMountedRef.current) setLoading(false)
      }
    },
    [callback],
  )

  return { fetchUser, loading, error }
}
